// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://santarosacountyclerk-vendor.aclarian.com',
  appName: 'Santa Rosa County Clerk | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub41a16486e54624bf6762ed3609a8709a',
  datadogApplicationId: '72e4a32b-2676-49b2-9d94-3befebac60e8',
  datadogService: 'invoicing_santarosaclerk_prod',
  ApiKey: 'Rq4@vLmP8#Tz2Yk%',
  env: 'Prod',
  version: packageInfo.version,
};
